export default "__VITE_ASSET__C$EHnrz3__"